import React from "react";
import ProfileNavigation from "../../../components/profile/ProfileNavigation";

import "../Profile.scss";

const MyAccountPage = () => {
  return (
    <div className="profile-wrapper">
      <ProfileNavigation></ProfileNavigation>
      <div className="py-8 px-12">
        <h2 className="text-2xl font-bold">Cuenta</h2>
      </div>
    </div>
  );
};

export default MyAccountPage;
